/**
 * The ReLayout function returns its children.
 * @returns The `children` prop is being returned.
 */

export default function ReLayout({children}) {
  return children;
}